import { del, get, post, put } from "./http-provider";
import qs from "qs";
export const SERVICE_URLS = {
  login: "/api/login",
  register: "/api/register",
  verifyOtp: "/api/verify-otp",
  requestVerifyOtp: "/api/request-verify-otp",
  requestForgotPassword: "/api/password/email",
  resetPassword: "/api/password/reset",
  talentHeroImages: "/api/talent/hero-images",
  userDetails: "/api/v2/user/",
  users: "/api/users/",
  partnerAndAgency: "/api/v2/partnerandagency?record_type",
  voteImages: "/api/users/vote-images?user_id",
  vote: "/api/v2/like-dislike",
  talent: "/api/v2/talent",
  categoriesTypes: "/api/v2/categories/types/",
  events: "/api/v2/events",
  news: "/api/v2/news",
  projects: "/api/v2/projects?page=",
  job: "/api/v2/job",
  notifications: "/api/notifications?user_id=",
  savedJobs: "/api/v2/saved-jobs",
  categoriesId: "/api/v2/categories/",
  talentPortfolio: "/api/v2/talent/",
  singleEventList: "/api/v2/events/",
  getSavedJobs: "/api/v2/saved-jobs",
  teams: "/api/v2/teams",
  missionSHE: "/api/v2/mission_she?page=",
  missionSHEDeatils: "/api/v2/mission_she/",
  newsDeatils: "/api/v2/news/",
  singleProject: "/api/v2/projects/",
  hireme: "/api/v2/hireme",
  favouritelike: "/api/v2/favouritelike",
  teamsPagenation: "/api/v2/teams?page=",
  chatMessage: "/api/chat/user/",
  deleteChat: "/api/chat/",
  deleteChatMessage: "/api/chat/message/",
  getMessages: "/api/chat/",
  sendMessage: "/api/chat/send",
  contactUs: "/api/v2/contactus",
  dashboardCounts: "/api/v2/",
  dropdowns: "/api/dropdowns",
  jobDropdowns: "/api/job-dropdowns",
  employers: "/api/v2/employers/",
  employersAuth: "/api/v2/",
  industriesDropdown: "/api/v2/industries",
  favouritedAndLikeEventAndNews: "/api/v2/user/",
  states: "/api/states/",
  cities: "/api/cities/",
  talentAuth: "/api/v2/",
  talentDetails: "/api/v2/talent/",
  newsletterSubscription: "/api/v2/newsletter-subscription",
};
const login = (data) => post(SERVICE_URLS.login, data);
const register = (data, params = {}) => {
  const query = qs.stringify(params, { addQueryPrefix: true });
  const url = SERVICE_URLS.register + query;
  return post(
    url,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", 
      },
      transformRequest: [(formData) => formData],
    }
  );
};

const verifyOtp = (data) => post(SERVICE_URLS.verifyOtp, data);
const requestVerifyOtp = (data) => post(SERVICE_URLS.requestVerifyOtp, data);
const requestForgotPassword = (data) =>
  post(SERVICE_URLS.requestForgotPassword, data);
const resetPassword = (data) => post(SERVICE_URLS.resetPassword, data);
const talentHeroImages = () => get(SERVICE_URLS.talentHeroImages);
const userDetails = (params) =>
  get(SERVICE_URLS.userDetails + `${params}/details`);
const users = (params) => get(SERVICE_URLS.users + params);
const userUpdate = (data, userId) =>
  post(`${SERVICE_URLS.users}${userId}`, data, true);
const partnerAndAgency = (params) =>
  get(SERVICE_URLS.partnerAndAgency + `=${params}`);
const voteImages = (userId, per_page) =>
  get(SERVICE_URLS.voteImages + `=${userId}&per_page=${per_page}`);
const vote = (data) => post(SERVICE_URLS.vote, data);
const talent = (params = {}) => {
  const query = qs.stringify(params, { addQueryPrefix: true });
  return get(SERVICE_URLS.talent + query);
};
const categoriesTypes = (types, per_page) => {
  return get(SERVICE_URLS.categoriesTypes + `${types}?per_page=${per_page}`);
};
const categoriesTypesWithPagination = (types, per_page, page_number) => {
  return get(SERVICE_URLS.categoriesTypes + `${types}?per_page=${per_page}&page=${page_number}`);
};
const events = (params = {}) => {
  const query = qs.stringify(params, { addQueryPrefix: true });
  return get(SERVICE_URLS.events + query);
};
const news = (params = {}) => {
  const query = qs.stringify(params, { addQueryPrefix: true });
  return get(SERVICE_URLS.news + query);
};
const projects = (page, per_page) => {
  return get(SERVICE_URLS.projects + `${page}?per_page=${per_page}`);
};
const job = (user_id, is_homepage, per_page) => {
  const params = new URLSearchParams();
  if (typeof is_homepage !== "undefined")
    params.append("is_homepage", is_homepage);
  if (per_page) params.append("per_page", per_page);
  if (user_id) params.append("user_id", user_id);
  return get(`${SERVICE_URLS.job}?${params.toString()}`);
};
const notifications = (params) => get(SERVICE_URLS.notifications + params);
const saveJobs = (data) => post(SERVICE_URLS.savedJobs, data);
const deleteSavedJobs = (data) => del(SERVICE_URLS.savedJobs, data);
const categoriesId = (params) => get(SERVICE_URLS.categoriesId + params);
const talentPortfolio = (talentId, userId) =>
  get(
    userId
      ? `${SERVICE_URLS.talentPortfolio}${talentId}?user_id=${userId}`
      : `${SERVICE_URLS.talentPortfolio}${talentId}`
  );
const singleEventList = (eventId, userId) =>
  get(
    userId
      ? `${SERVICE_URLS.singleEventList}${eventId}?user_id=${userId}`
      : `${SERVICE_URLS.singleEventList}${eventId}`
  );
const getSavedJobs = (page, talentId, userId) =>
  get(
    `${SERVICE_URLS.getSavedJobs}?talent_id=${talentId}&user_id=${userId}&page=${page}`
  );
const teams = (id, per_page) =>
  get(
    id
      ? `${SERVICE_URLS.teams}/${id}?Per_page=${per_page}`
      : `${SERVICE_URLS.teams}`
  );
const missionSHE = (params) => get(SERVICE_URLS.missionSHE + params);
const missionSHEDeatils = (params) =>
  get(SERVICE_URLS.missionSHEDeatils + params);
const newsDeatils = (newsId, userId) =>
  get(
    userId
      ? `${SERVICE_URLS.newsDeatils}${newsId}&user_id=${userId}`
      : `${SERVICE_URLS.newsDeatils}${newsId}`
  );
const singleProject = (params) => get(SERVICE_URLS.singleProject + params);
const hireme = (data) => post(SERVICE_URLS.hireme, data);
const favouritelike = (data) => post(SERVICE_URLS.favouritelike, data);
const teamsPagenation = (params) => get(SERVICE_URLS.teamsPagenation + params);
const chatMessage = (params) => get(SERVICE_URLS.chatMessage + params);
const deleteChat = (data) => del(SERVICE_URLS.deleteChat + data);
const deleteChatMessage = (data) => del(SERVICE_URLS.deleteChatMessage + data);
const getMessages = (chatId) =>
  get(`${SERVICE_URLS.getMessages}${chatId}/messages?user_id=${chatId}`);
const sendMessage = (chatheadsId, userId, data) =>
  post(SERVICE_URLS.sendMessage, {
    chat_head_id: chatheadsId,
    sender_id: userId,
    message: data,
  });
const contactUs = (data) => post(SERVICE_URLS.contactUs, data);
const newsletterSubscription = (data) => post(SERVICE_URLS.newsletterSubscription, data);
const dashboardCounts = (roleId, userRole, employerId) => {
  const path =
    userRole === "employer"
      ? `employer/${employerId}/dashboard/count`
      : `user/${roleId}/dashboard/count`;

  return get(SERVICE_URLS.dashboardCounts + path);
};
const dropdowns = () => get(SERVICE_URLS.dropdowns);
const jobDropdowns = () => get(SERVICE_URLS.jobDropdowns);
const employers = (employerId) => get(SERVICE_URLS.employers + employerId);

const employersAuth = (employerId, EmployerData) => {
  const path = employerId ? `employers/${employerId}` : `employers`;
  return post(SERVICE_URLS.employersAuth + path, EmployerData, true);
};
const industriesDropdown = (per_page) =>
  get(SERVICE_URLS.industriesDropdown + `?per_page=${per_page}`);
const favouritedAndLikeEventAndNews = (userId, instance_types) =>
  get(
    SERVICE_URLS.favouritedAndLikeEventAndNews +
      `${userId}/favouritelike?instance_type=${instance_types}`
  );
const states = (params) => get(SERVICE_URLS.states + params);
const cities = (params) => get(SERVICE_URLS.cities + params);
const talentAuth = (talentId, talentData) => {
  const path = talentId ? `talent/${talentId}` : `talent`;
  return post(SERVICE_URLS.talentAuth + path, talentData, true);
};
const talentDetails = (params) => get(SERVICE_URLS.talentDetails + params);
// const updateUserProfile = (data) => put(SERVICE_URLS.updateUserProfile, data);
const apiServices = {
  login,
  register,
  verifyOtp,
  requestVerifyOtp,
  requestForgotPassword,
  resetPassword,
  talentHeroImages,
  userDetails,
  users,
  userUpdate,
  partnerAndAgency,
  voteImages,
  vote,
  talent,
  categoriesTypes,
  categoriesTypesWithPagination,
  events,
  news,
  projects,
  job,
  notifications,
  saveJobs,
  deleteSavedJobs,
  categoriesId,
  talentPortfolio,
  singleEventList,
  getSavedJobs,
  teams,
  missionSHE,
  missionSHEDeatils,
  newsDeatils,
  singleProject,
  hireme,
  favouritelike,
  teamsPagenation,
  chatMessage,
  deleteChat,
  deleteChatMessage,
  getMessages,
  sendMessage,
  contactUs,
  dashboardCounts,
  dropdowns,
  jobDropdowns,
  employers,
  employersAuth,
  industriesDropdown,
  favouritedAndLikeEventAndNews,
  states,
  cities,
  talentAuth,
  talentDetails,
  newsletterSubscription,
};

export default apiServices;
